import Vue from 'vue'

const client = Vue.prototype.$api

export default {
  getPaymentInfo (appointmentId) {
    return client.get('Payments/PaymentInfo', { params: { appointmentId: appointmentId } })
  },
  updateBizumDirectStatus (data) {
    return client.post('Payments/UpdateBizumDirectStatus', data)
  },
  sendPaytpvPayment (data) {
    return client.post('Payments/Paycomet', data)
  },
  sendOpenpayPayment (data) {
    return client.post('Payments/Openpay/RegisterPayment', data)
  }
}


// WEBPACK FOOTER //
// ./src/repositories/PaymentsRepository.js